module.exports = "https://static.wmbcdn.com/uniweb/images/06c7f493a0b3771f22f7e8474cafb7dd.svg";